<template>
  <div>
    <ul data-test="appList__product-cards" class="column-321 mb-5">
      <li
        v-for="product in products"
        :key="product.name"
        data-test="appList__product-card"
      >
        <TheNuxtLink
          :to="`/${locale}/marketplace/products/${product.alias}`"
          :title="product.name"
          class="block h-full w-full rounded border border-solid border-white bg-white p-3 shadow-normal shadow-gray-400 hover:border-blue-400 tablet:min-h-[280px] tablet:p-4"
          @click="handleClick(product.name)"
        >
          <div class="relative mb-2.5 inline-block">
            <TheProductIcon
              class="h-14 w-14 basis-14 tablet:h-20 tablet:w-20 tablet:basis-20"
              :src="product.icon"
              :alt="product.name"
            />
          </div>

          <div>
            <h3 class="text-h5 mb-2">{{ product.name }}</h3>
            <p class="text-sm text-gray-600">{{ product.supplier }}</p>
            <ul class="flex flex-wrap pt-2.5">
              <li
                v-for="item in product.tags"
                :key="hash(item)"
                class="mb-1 mr-1"
              >
                <span
                  class="block rounded bg-gray-100 px-2 py-1 text-xs text-gray-600"
                >
                  {{ item }}
                </span>
              </li>
            </ul>
          </div>
        </TheNuxtLink>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
  import hash from 'object-hash';

  import type { ICategoryProduct } from '@/assets/types/api/Categories';

  interface IProps {
    products: ICategoryProduct[];
  }

  withDefaults(defineProps<IProps>(), {
    products: () => [],
  });

  const { locale } = useI18n();

  const route = useRoute();

  const handleClick = (name: string): void => {
    window.gtag('event', 'site_click', {
      Item: 'Product',
      Item_Cate: route.params.subcategory,
      Item_Name: name,
    });
  };
</script>
